import { Toolbar } from 'primereact/toolbar';
import { BreadCrumb } from 'primereact/breadcrumb';
import ProgressTables from '../components/Progress/ProgressTables';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../redux/hooks';
import { selectedReportsFilter } from '../redux/reducers/filterReportsSlice';
import { validateIfWeGotFiltersApplyInProgressPage } from '../businessLogicService/validateIfWeGotFiltersApplyInProgressPage';
import { useEffect, useState, Suspense } from 'react';
import ProgressFilters from '../components/Progress/ProgressFilters/ProgressFilters';

const Progress = () => {
  const navigate = useNavigate();
  const breadcrumbItems = [{ label: 'Monitor', command: () => navigate('/quick-data') }, { label: 'Progress' }];
  const reportsFilterRedux = useAppSelector(selectedReportsFilter);
  const [classesQueryLoaded, setClassesQueryLoaded] = useState<boolean>(false);
  const home = { icon: 'nc_icon-nc_home icon-sm', command: () => navigate('/') };

  useEffect(() => {
    if (reportsFilterRedux?.classes?.length && reportsFilterRedux?.roadmaps?.id) {
      setClassesQueryLoaded(true);
    }
  }, [reportsFilterRedux?.classes?.length, reportsFilterRedux?.roadmaps?.id]);

  return (
    <div className="grid nc_content-frame nc_page-inner">
      <Toolbar role="section" className="col-10 col-offset-1 nc_page-header" center={<h1>Progress</h1>} />
      <BreadCrumb className="col-10 col-offset-1" model={breadcrumbItems} home={home} />
      <div className="col-10 col-offset-1 flex flex-column align-items-center">
        <ProgressFilters />
      </div>
      {classesQueryLoaded && validateIfWeGotFiltersApplyInProgressPage(reportsFilterRedux) ? (
        <Suspense>
          <div className="col-10 col-offset-1 flex flex-column align-items-center">
            <ProgressTables />
          </div>
        </Suspense>
      ) : (
        <div className="nc_block col-10 col-offset-1">
          <h3 className="text-center w-full text-base font-medium line-height-4">
            Please use the Report Settings above to get started!
          </h3>
        </div>
      )}
    </div>
  );
};

export default Progress;
